import { useQuery } from '@hooks/reactQuery';

import { getCustomPolygons } from '@api/map';

import { refetchOptions } from '@constants/common';
import { CUSTOM_POLYGON } from '@constants/queryKeys';

export const useQueryPolygons = () => {
	const { data, isLoading } = useQuery({
		queryKey: [CUSTOM_POLYGON],
		queryFn: getCustomPolygons,
		...refetchOptions,
	});

	return {
		polygons: data?.items || [],
		isLoadingPolygons: isLoading,
	};
};
